import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { ProgramService } from '@univacity/angular/datas';
import { Program } from '@univacity/shared/types';

import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgramResolver implements Resolve<Observable<Program>> {
  constructor(private svc: ProgramService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Program> {
    return this.svc
      .findOne(route.params['id'], {
        ...route.queryParams,
        populate: ['intakes'],
        increaseView: true,
      })
      .pipe(
        catchError((error) => {
          if (error.statusCode === 400) this.router.navigate(['/404']);
          throw error;
        })
      );
  }
}
